import { atom } from 'recoil';
import { Option } from '@/types/api/mypage/options';
import persistAtom from './recoilPersist';

/** オプション一覧取得APIの結果を画面で扱いやすい形に保持する型。 */
export type OptionsInfoStateType = {
  option_inquiry_number: string;
  options: Option[];
};

/**
 * 契約中オプション一覧を保持する state。
 * 契約情報画面やオプション画面の複数セクションで共通参照するため、取得結果をまとめて保持する。
 */
export const OptionsInfoState = atom<OptionsInfoStateType>({
  key: 'OptionsInfoState',
  default: {
    option_inquiry_number: '',
    options: [],
  },
  effects_UNSTABLE: [persistAtom],
});

export default OptionsInfoState;
